import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Modal from '@mui/material/Modal';
import { Box, Paper } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import Button from 'src/component/UI/Button';
import toast from 'src/utils/toast';
import './DisplayInfoModal.scss';
import { useTranslation } from 'src/i18n';

export default function DisplayInfoModal (props) {
  const [copiedField, setCopiedField] = useState(null);
  const { t } = useTranslation();

  const handleCopy = (text, fieldKey, fieldLabel) => {
    navigator.clipboard.writeText(text).then(
      () => {
        setCopiedField(fieldKey);
        toast.success(t('toast.copiedToClipboard', { field: fieldLabel }));
        setTimeout(() => {
          setCopiedField(null);
        }, 2000);
      },
      () => {
        toast.error(t('toast.failedToCopyClipboard'));
      }
    );
  };

  return (
    <Modal
      data-testid='display-info-modal'
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby='display-info-modal-title'
    >
      <div className='modal display-info-modal'>
        <h2 className='display-info-modal-title'>{props.title || 'Information'}</h2>
        <div className='display-info-modal-warning'>
          <WarningAmberIcon className='display-info-modal-warning__icon' />
          <div className='display-info-modal-warning__text'>
            <span className='display-info-modal-warning__title'>{t('users.userCredentialsWarningTitle')}</span>
            <span className='display-info-modal-warning__body'>{t('users.userCredentialsWarningBody')}</span>
          </div>
        </div>

        <Box className='display-info-modal-content'>
          <Paper elevation={0} className='display-info-field'>
            <div className='display-info-field-label'>{t('users.email')}</div>
            <div className='display-info-field-value'>
              <span className='display-info-field-text'>{props.data?.email || 'N/A'}</span>
              <Button
                className={classNames('display-info-copy-button', {
                  'display-info-copy-button-copied': copiedField === 'email',
                })}
                onClick={() => handleCopy(props.data?.email, 'email', t('users.email'))}
                icon={copiedField === 'email' ? <CheckIcon style={{ fontSize: 16 }} /> : <ContentCopyIcon style={{ fontSize: 16 }} />}
                compact
                ariaLabel={t('users.email')}
              />
            </div>
          </Paper>

          <Paper elevation={0} className='display-info-field'>
            <div className='display-info-field-label'>{t('users.password')}</div>
            <div className='display-info-field-value'>
              <span className='display-info-field-text'>{props.data?.password || 'N/A'}</span>
              <Button
                className={classNames('display-info-copy-button', {
                  'display-info-copy-button-copied': copiedField === 'password',
                })}
                onClick={() => handleCopy(props.data?.password, 'password', t('users.password'))}
                icon={copiedField === 'password' ? <CheckIcon style={{ fontSize: 16 }} /> : <ContentCopyIcon style={{ fontSize: 16 }} />}
                compact
                ariaLabel={t('users.password')}
              />
            </div>
          </Paper>
        </Box>

        <div className='button-bar'>
          <Button variant="contained" onClick={props.handleClose}>{t('common.close')}</Button>
        </div>
      </div>
    </Modal>
  );
}

DisplayInfoModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  data: PropTypes.object
};

DisplayInfoModal.defaultProps = {
};
